// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Dialog, DialogContent } from '@crehana/ui';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

export const DialogBox = styled(Dialog)`
  max-width: 696px;
  margin: 0 auto;
  button[data-testid='close-dialog'] {
    margin-top: 14px;
    margin-right: 14px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const DialogContentBox = styled(DialogContent)`
  margin-left: 0px !important;
  margin-right: 0px !important;
  max-width: 100%;
  width: 100%;
`;

export const DialogContentInfoBox = styled(DialogContent)`
  margin: 0px !important;
  padding-top: 0px;
  padding-bottom: 0px;
  max-width: 100%;
  width: 100%;
  min-height: 224px;
`;

export const DialogImgBox = styled.div`
  height: 256px;
  padding: 0px 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 8px;
  @media (max-width: 768px) {
    height: auto;
    padding: 0px;
  }
`;

export const ControlSlider = styled.div<{ isDark: boolean }>(
  ({ theme, isDark }) => css`
    div {
      p {
        color: ${isDark && theme.colors.white};
      }
    }
  `,
);
